export const PRODUCTION_TIME_ZONE = "America/Argentina/Buenos_Aires";

const productionDateFormatter = new Intl.DateTimeFormat("es-AR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: PRODUCTION_TIME_ZONE,
});

export function formatProductionDate(value) {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : productionDateFormatter.format(date);
}

export function formatProductionQuantity(value, unit) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  const quantity = number.toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
  return unit ? `${quantity} ${unit}` : quantity;
}

export function formatProductionYield(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return `${(number * 100).toLocaleString("es-AR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;
}
